const menu = {};
export const contextMenuItems: any = {
  appHeader: {
  },
  leftmenu: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' }
  },
  leftpane: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' }
  },
  rightpane: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' }
    //"addlangdrop":{ 'name' : 'Add Language', 'icon' : 'add'}
  },
  middlepane: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' }
  },

  // NEW APP NAVIGATION TYPES (Angular 21)
  app_navigation: {},
  app_menu: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' },
    addimportmenuitem: { name: 'Add Import Menu', icon: 'add' }
  },
  menu_item: {
    addmenuitemabove: { name: 'Add Menu Above', icon: 'add' },
    addmenuitem: { name: 'Add Menu Below', icon: 'add' },
    adddelete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  // MENU_GROUP - Menu group container (same as old menugroup)
  menu_group: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' },
    addimportmenuitem: { name: 'Add Import Menu', icon: 'add' },
    sep1: '-------',
    adddelete: { name: 'Delete', icon: 'delete', disabled: false },
    sep2: '-------',
    addmenugroupabove: { name: 'Add Menu Group Above', icon: 'add' },
    addmenugroupafter: { name: 'Add Menu Group Below', icon: 'add' }
  },
  // MENU_GROUP with menu items only (Angular 21)
  menu_group_with_menu: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addimportmenuitem: { name: 'Add Import Menu', icon: 'add' },
    sep1: '-------',
    adddelete: { name: 'Delete', icon: 'delete', disabled: false },
    sep2: '-------',
    addmenugroupabove: { name: 'Add Menu Group Above', icon: 'add' },
    addmenugroupafter: { name: 'Add Menu Group Below', icon: 'add' }
  },
  user_menu_group: {
    addchildusermenu: { name: 'Add Child Menu', icon: 'add' }
  },
  // USER_SETTINGS - User settings container (Angular 21)
  user_settings: {
    // Dynamic options for Add Language and Add Logout are added in screens.component.ts
  },
  // USER_MENU - Individual user menu item
  user_menu: {
    addusermenuabove: { name: 'Add Menu Above', icon: 'add' },
    addusermenubelow: { name: 'Add Menu Below', icon: 'add' },
    adddelete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  lefthamburgermenu: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' }
  },
  menugroup: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    addmenuitems: { name: 'Add Child Menus', icon: 'add' },
    sep1: '-------',
    adddelete: { name: 'Delete', icon: 'delete', disabled: false },
    sep2: '-------',
    addmenugroupabove: { name: 'Add Menu Group Above', icon: 'add' },
    addmenugroupafter: { name: 'Add Menu Group Below', icon: 'add' }
  },
  menugroupwithmenu: {
    addmenugroup: { name: 'Add Child Menu Group', icon: 'add' },
    addchildmenuitem: { name: 'Add Child Menu', icon: 'add' },
    //"addmenuitems": { 'name': 'Add Child Menus', 'icon': 'add' },
    sep1: '-------',
    adddelete: { name: 'Delete', icon: 'delete', disabled: false },
    sep2: '-------',
    addmenugroupabove: { name: 'Add Menu Group Above', icon: 'add' },
    addmenugroupafter: { name: 'Add Menu Group Below', icon: 'add' }
  },
  menuitem: {
    addmenuitemabove: { name: 'Add Menu Above', icon: 'add' },
    addmenuitem: { name: 'Add Menu Below', icon: 'add' },
    adddelete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  user: {
    addchildusermenu: { name: 'Add Child Menu', icon: 'add' }
    //"addLogout": { 'name': 'Add Logout', 'icon': 'add' }
  },
  usermenu: {
    addusermenuabove: { name: 'Add Menu Above', icon: 'add' },
    addusermenubelow: { name: 'Add Menu Below', icon: 'add' },
    adddelete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  grid: {
    addtablecolumns: { name: 'Add Columns', icon: 'add' },
  },
  actionbar: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' },
    addbuttongroup: { name: 'Add Button Group', icon: 'add' }
  },
  leftactionbar: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' },
    addbuttongroup: { name: 'Add Button Group', icon: 'add' }
  },
  rightactionbar: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' },
    addbuttongroup: { name: 'Add Button Group', icon: 'add' }
  },
  buttongroup: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' },
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  restrictedbuttongroup: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' }
  },
  dropdownbutton: {
    addbuttons: { name: 'Add Action Buttons', icon: 'add' },
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  captionbar: {
    addcaptions: { name: 'Add Captions', icon: 'add' }
  },
  form: {
    addformfields: { name: 'Add Form Fields', icon: 'add' },
    addformsection: { name: 'Add Form Section', icon: 'add' },
    addformtab: { name: 'Add Tab View', icon: 'add' },
    sep1: '-------',
    adddatagrid: { name: 'Add Child Datagrid', icon: 'add' },
    addstandardgrid: { name: 'Add Standard Datagrid', icon: 'add' },
    addqueryview: { name: 'Add Query View', icon: 'add' },
    addcustombuttons: { name: 'Add Action Buttons', icon: 'add' },
    sep2: '-------',
    adddcustomcomponent: { name: 'Add Custom Component', icon: 'add' },
    htmlcontainer: { name: 'Add Html Container', icon: 'add' },
    inlinetext: { name: 'Add Inline Text', icon: 'add' }
  },
  htmlcontainer: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  formfield: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  tabview: {
    /* "convertToSection": { 'name': 'Convert to Section', 'icon': 'add' }, */
    addtabs: { name: 'Add Tabs', icon: 'add' },
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  tab: {
    addformfields: { name: 'Add Form Fields', icon: 'add' },
    addformsection: { name: 'Add Form Section', icon: 'add' },
    addformtab: { name: 'Add Tab View', icon: 'add' },
    adddatagrid: { name: 'Add Child Datagrid', icon: 'add' },
    addstandardgrid: { name: 'Add Standard Datagrid', icon: 'add' },
    addqueryview: { name: 'Add Query View', icon: 'add' },
    addcustombuttons: { name: 'Add Action Buttons', icon: 'add' },
    htmlcontainer: { name: 'Add Html Container', icon: 'add' },
    inlinetext: { name: 'Add Inline Text', icon: 'add' },
    adddcustomcomponent: { name: 'Add Custom Component', icon: 'add' },
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  formsection: {
    addformfields: { name: 'Add Form Fields', icon: 'add' },
    addformsection: { name: 'Add Form Section', icon: 'add' },
    addformtab: { name: 'Add Tab View', icon: 'add' },
    sep1: '-------',
    adddatagrid: { name: 'Add Child Datagrid', icon: 'add' },
    addstandardgrid: { name: 'Add Standard Datagrid', icon: 'add' },
    addqueryview: { name: 'Add Query View', icon: 'add' },
    addcustombuttons: { name: 'Add Action Buttons', icon: 'add' },
    sep2: '-------',
    adddcustomcomponent: { name: 'Add Custom Component', icon: 'add' },
    convertToTab: { name: 'Convert to Tab', icon: 'add' },
    htmlcontainer: { name: 'Add Html Container', icon: 'add' },
    inlinetext: { name: 'Add Inline Text', icon: 'add' },
    sep3: '-------',
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  tablesearch: {
    addsearchfields: { name: 'Add Fields', icon: 'add' }
  },
  searchfilter: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  quickfilter: {
    addquickfilterfields: { name: 'Add Fields', icon: 'add' }
  },
  filtersandsearch: {
  },
  homepage: {
    addtiles: { name: 'Add Tiles', icon: 'add' }
  },
  delete: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  pageview: {
    adddcustomcomponent: { name: 'Add Custom Component', icon: 'add' },
    htmlcontainer: { name: 'Add Html Container', icon: 'add' },
    inlinetext: { name: 'Add Plain Display Text', icon: 'add' }
  },
  titlebar: {
    adddcustomcomponent: { name: 'Add Custom Component', icon: 'add' },
    htmlcontainer: { name: 'Add Html Container', icon: 'add' },
    inlinetext: { name: 'Add Plain Display Text', icon: 'add' }
  },
  breadcrumb: {
  },
  pagetitle: {
  },
  workflowactionbar: {
  },
  inlinetext: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  customcomponent: {
    delete: { name: 'Delete', icon: 'delete', disabled: false }
  },
  totalrecordscount: {
  }
};
